module.exports = __webpack_public_path__ + "assets/img/useMedicine-bg.7417ba6c.png";